/**
 * Walk an error `cause` chain looking for a string `kind` discriminant.
 *
 * Route param sentinels (invalid ticker / sector) share this walker so a third
 * route does not paste a third copy of the depth-bounded recursion. Depth is
 * also the cycle guard — a self-referencing `cause` is malformed rather than
 * impossible.
 */

const MAX_CAUSE_DEPTH = 4;

export function errorHasKind(error: unknown, kind: string, depth = MAX_CAUSE_DEPTH): boolean {
  if (depth <= 0 || typeof error !== 'object' || error === null) return false;
  if ((error as { readonly kind?: unknown }).kind === kind) return true;
  return errorHasKind((error as { readonly cause?: unknown }).cause, kind, depth - 1);
}

/** Exported for depth-bound tests only. */
export const ERROR_CAUSE_MAX_DEPTH = MAX_CAUSE_DEPTH;
